module.exports = __webpack_public_path__ + "media/images/soar/operation_cartoon-46bb3d208b5ab5995fd33a4b08af3d16.png";